import React, { useState } from 'react';

import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';

import { AudienceCard } from '../modules/audience-card';
import { CategoryDashboard } from '../modules/audience-category-dashboard';
import { default as UploadedAudiencesModal } from 'pages/audiences/editor';
import { default as uploadedEditorActions } from 'pages/audiences/editor/actions';
import { useDispatch } from 'react-redux';
import { useOverallTableDashboardData } from '../overall-dashboard/v2/hook';

import { isPatisonOutdoorSelfServeUser } from 'states/profile/business-rules';

const sortingOptions = [
    {
        label: 'Sort by: Newest',
        value: '_created',
        direction: 'desc',
    },
    {
        label: 'Sort by: Last Updated',
        value: 'lastRefreshed',
        direction: 'desc',
    },
    {
        label: 'Sort by: Name',
        value: 'name',
        direction: 'asc',
    },
];

const UploadedLayout = ({
    audienceSegments,
    onSearch,
    segmentCount,
    activeAudience,
    isModalOpen,
    organizationId,
}) => {
    const { canEditAudiences } = useOverallTableDashboardData();
    const [audienceValue, setAudienceValue] = useState(null);

    const dispatch = useDispatch();

    const linkToAudienceTab = {
        pathname: '/audiences/all',
        query: { audienceTab: 'advertiser_data' },
        linkBackLabel: 'Advertiser Data',
    };

    const openUploadedEditorActions = (audienceId, target) => {
        setAudienceValue(audienceId);
        dispatch(uploadedEditorActions.initialize(audienceId, target));
        dispatch(uploadedEditorActions.openModal(audienceId));
    };

    return (
        <>
            <CategoryDashboard
                audienceSegments={audienceSegments}
                onSearch={onSearch}
                segmentCount={segmentCount}
                createEditAction={() => openUploadedEditorActions(null, 'uploaded')}
                activeAudience={activeAudience}
                organizationId={organizationId}
                sortingOptions={sortingOptions}
                description={
                    'Onboarding first-party data via hashed identification, this segment establishes a secure, privacy-compliant framework for high-precision targeting.'
                }
                title={'Uploaded'}
                linkToAudienceTab={linkToAudienceTab}
                bannerImagePath={'/images/audience-segments/banners/uploaded.png'}
                renderAudienceCard={segment => (
                    <AudienceCard
                        segment={segment}
                        onClick={
                            !isPatisonOutdoorSelfServeUser()
                                ? () => openUploadedEditorActions(segment.id, 'uploaded')
                                : undefined
                        }
                        active={segment.id === activeAudience}
                        organizationId={organizationId}
                    />
                )}
                customActions={
                    canEditAudiences && !isPatisonOutdoorSelfServeUser() ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => openUploadedEditorActions(null, 'uploaded')}
                        >
                            <AddIcon /> New Audience
                        </Button>
                    ) : null
                }
            />
            {isModalOpen && <UploadedAudiencesModal audienceId={audienceValue} />}
        </>
    );
};

export default UploadedLayout;
